import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gs0008',
    ecrans: ['00-2']
});
